<template>
  <div :class="classes">
    <span v-if="label && !labelIcon" class="control-select__label">{{ label }}: </span>

    <!-- legend title -->
    <legend-title v-if="labelIcon" icon-name="filter" :title="label" class="control-select__label" />

    <!-- dropdown -->
    <div class="dropdown control-select__dropdown text-legend">
      <button aria-haspopup="true" aria-expanded="false" data-toggle="dropdown" type="button" class="dropdown-btn">
        <span class="dropdown-btn__text">{{ lazyValue }}</span>
      </button>

      <i class="fas fa-caret-down dropdown-icon" />

      <!-- dropdown menu -->
      <ul class="dropdown-menu">
        <li v-for="item in selections" :key="item" :data-value="item" @click="updateLazyValue">
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectFilter',
  components: {
    LegendTitle: () => import('@/components/ui/LegendTitle.vue'),
  },
  props: {
    fluid: Boolean,
    label: String,
    labelIcon: Boolean,
    selections: {
      type: Array,
      required: true,
    },
    value: null,
  },
  computed: {
    classes() {
      return {
        'control-select': true,
        'control-select--fluid': this.fluid,
        'text--primary': true,
      };
    },
  },
  data() {
    return {
      lazyValue: this.value,
    };
  },
  methods: {
    updateLazyValue(e) {
      // get selected value
      const { value } = e.target.dataset;

      // update value
      this.lazyValue = value;
      // emit value
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.control-select {
  display: flex;

  &--fluid {
    .control-select__dropdown {
      flex: 1 1 auto;

      .dropdown-btn {
        width: 100%;
        text-align: left;
      }
    }
  }

  &__label {
    margin-right: 15px;
    font-size: 16px;
  }

  &__dropdown {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #002469;

    .dropdown-icon {
      margin-left: auto;
    }

    // overwrite bootstrap css
    ::v-deep .dropdown-backdrop {
      z-index: 8;
    }

    // inherit UOB CSS
    .dropdown-menu {
      z-index: 9;
      white-space: nowrap;
      padding: 0;

      > li {
        color: #005eb8;
        text-align: left;
        font-size: 15px;
        padding: 15px 15px;
        cursor: pointer;
        font-family: "Noto Sans Bold", sans-serif;
        font-weight: 700;
        margin: 0;

        &:hover,
        &:focus {
          background: #004585;
          color: #fff;
        }
      }
    }
  }
}
</style>
